import {
  Button, Container, MenuItem, TextField,
} from '@mui/material';
import React, {
  useEffect, useState, useRef, useContext,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCategories } from '../../../../Redux/Models/master';
import { createRequestItem } from '../../../../Redux/Models/request';
import { fetchClient } from '../../../../Utils/helpers';
import { getUserData } from '../../../../Utils/storages';
import Elements from '../../../Elements';
import AlertContext from '../../../../Context/AlertContext';

export default function Dev({
  classes, error, message, isLoading, newRequestItem,
}) {
  const photoRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { master } = useSelector((state) => state);
  const user = getUserData();
  const { openAlert } = useContext(AlertContext);
  const { t } = useTranslation();

  const [fields, setFields] = useState({
    name: '',
    category_id: '-',
    notes: '',
    photo: '',
  });

  const [openConfirm, setOpenConfirm] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChangeField = (e) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  const photoTrigger = (ref) => {
    ref?.current?.click();
  };

  const handleChangePhoto = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      const acceptedExt = ['png', 'jpg', 'jpeg', 'gif'];
      const fileExt = file.name.split('.').reverse()[0];

      if (!acceptedExt.includes(fileExt?.toLowerCase())) {
        openAlert({ message: 'Sorry, You only can upload image file', severity: 'error', open: true });
        return;
      }

      const fileSize = file.size;
      if (fileSize > (10000 * 1000)) {
        openAlert({ message: 'Sorry, maximum file size is 10MB', severity: 'error', open: true });
        return;
      }

      openAlert({ message: 'Uploading...', severity: 'info', open: true });
      const body = new FormData();
      body.append('file', file);

      fetchClient({
        method: 'POST',
        url: '/upload',
        data: body,
      }).then((res) => {
        setFields({ ...fields, photo: res.data.data.url });
        openAlert({ message: 'Successfully upload...', severity: 'success', open: true });
      }).catch((err) => {
        openAlert({ message: err.response.data.message, severity: 'error', open: true });
      });
    }
  };

  useEffect(() => {
    dispatch(getCategories());
  }, []);

  useEffect(() => {
    if (error) {
      openAlert({
        open: true,
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  const wanToContinue = () => {
    // check validity
    if (fields.name && fields.category_id !== '-') {
      setOpenConfirm(true);
    } else {
      openAlert({
        open: true,
        severity: 'error',
        message: 'Please complete the form!',
      });
    }
  };

  const handleSubmitRequest = () => {
    setSubmitted(true);
    dispatch(createRequestItem(user.id, fields));
  };

  useEffect(() => {
    if (submitted && newRequestItem) {
      navigate(-1);
    }
  }, [submitted, newRequestItem]);

  return (
    <Elements.PageBase navigate={navigate} noNav>
      <div className={classes.root}>
        <Elements.Navigator title={t('reqWine.title')} />

        <Container>
          <h4 className="mt-3">{t('reqWine.detail')}</h4>
          <div className="mt-3">
            <div className="s-16">
              {t('reqWine.field1')}
              <span className="primary-green">*</span>
            </div>
            <TextField size="small" sx={{ mt: 1 }} fullWidth placeholder="Type wine name" name="name" onChange={handleChangeField} value={fields.name} />
          </div>
          <div className="mt-3">
            <div className="s-16">
              {t('reqWine.field2')}
              <span className="primary-green">*</span>
            </div>
            <TextField size="small" sx={{ mt: 1 }} fullWidth select name="category_id" value={fields.category_id} onChange={handleChangeField}>
              <MenuItem value="-" disabled>Choose category</MenuItem>
              {master.categories.map((category) => (
                <MenuItem value={category.id} key={category.id}>{category.name}</MenuItem>
              ))}
            </TextField>
          </div>
          <div className="mt-3">
            <div className="s-16">{t('reqWine.field3')}</div>
            <TextField size="small" sx={{ mt: 1 }} multiline fullWidth placeholder="Type here" name="notes" value={fields.notes} onChange={handleChangeField} />
          </div>

          <div className="mt-3">
            <div>{t('reqWine.photo')}</div>
            <div className="mt-2">
              <input type="file" name="photo" hidden ref={photoRef} onChange={handleChangePhoto} />
              {fields.photo
                ? (
                  <img
                    onClick={() => photoTrigger(photoRef)}
                    width="120"
                    height="120"
                    alt="requested item"
                    src={fields.photo}
                    className="rounded link cover"
                  />
                ) : (
                  <div className="upload-sect" onClick={() => photoTrigger(photoRef)}>
                    Photo
                  </div>
                )}
            </div>
          </div>
        </Container>

        <div className="floating-action">
          <Container>
            <Button fullWidth type="submit" size="large" variant="contained" className="btn-contained" onClick={wanToContinue}>
              Request Wine
            </Button>
          </Container>
        </div>
      </div>

      <Elements.ConfirmationModal
        open={openConfirm}
        handleClose={() => setOpenConfirm(false)}
        desc={(
          <div>
            Make sure filled data is correct
          </div>
        )}
        handleAgree={handleSubmitRequest}
        isLoading={isLoading}
      />
    </Elements.PageBase>
  );
}
